import { render, staticRenderFns } from "./SupplierProductEvents.vue?vue&type=template&id=2753f3dc&scoped=true"
import script from "./SupplierProductEvents.vue?vue&type=script&lang=js"
export * from "./SupplierProductEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2753f3dc",
  null
  
)

export default component.exports